export default "__VITE_ASSET__COEouOml__"